//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { environment } from "../environments/environment";

/* eslint-disable */
// ReSharper disable InconsistentNaming
@Injectable({
    providedIn: 'root'
})
export class ApiClientService {
    private baseUrl = environment.apiUrl;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private http: HttpClient) {
        this.httpFetch = this.createHttpFetch();
    }

    public async getIpAddress(): Promise<any> {
        try {
            const data = await firstValueFrom(this.http.get('https://api.ipify.org/?format=json'));
            return data;
        } catch (error) {
            throw error;
        }
    }

    private httpFetch: (input: string, init?: RequestInit) => Promise<Response>;

    private createHttpFetch() {
        return async (input: string, init?: RequestInit): Promise<Response> => {
            const method = init?.method || 'GET';
            const headers = new HttpHeaders(init?.headers as any);
            const body = init?.body as string;

            try {
                const observable = this.http.request(method, input, {
                    body: body,
                    headers: headers,
                    observe: 'response',
                    responseType: 'json'
                });

                console.log("Making HTTP request:", method, input);
                const response = await firstValueFrom(observable);
                console.log("HTTP response received:", response);

                // Convert Angular HttpResponse to fetch-like Response
                return {
                    status: response.status,
                    statusText: response.statusText,
                    headers: {
                        forEach: (callback: (value: string, key: string) => void) => {
                            response.headers.keys().forEach(key => {
                                callback(response.headers.get(key) || '', key);
                            });
                        },
                        get: (name: string) => response.headers.get(name)
                    },
                    text: async () => typeof response.body === 'string' ? response.body : JSON.stringify(response.body),
                    json: async () => response.body,
                    ok: response.status >= 200 && response.status < 300,
                } as any;
            } catch (error) {
                throw error;
            }
        };
    }

    private async executeRequest<T>(request: Promise<Response>): Promise<T> {
        const response = await request;
        return this.processResponse<T>(response);
    }

    private processResponse<T>(response: Response): Promise<T> {
        // Your existing process methods will handle this
        // We'll keep all your existing process methods exactly as they are
        return response.text().then((_responseText) => {
            // Your existing JSON parsing logic here
            return JSON.parse(_responseText, this.jsonParseReviver);
        });
    }

    cijeneInoGET(): Promise<string> {
        let url_ = this.baseUrl + "/api/CijeneIno";

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_)
            .then(r => r.text()); // IMPORTANT: plain string, not JSON.parse
    }

    cijeneInoPOST(body: string): Promise<void> {
        let url_ = this.baseUrl + "/api/CijeneIno";

        let options_: RequestInit = {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        };

        return this.httpFetch(url_, options_)
            .then(() => { });
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    anonimniKontaktPOST(body: Anonimni_kontakt | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnonimniKontakt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processAnonimniKontaktPOST(_response);
        });
    }

    protected processAnonimniKontaktPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    anonimniKontaktAll(): Promise<Anonimni_kontakt[]> {
        let url_ = this.baseUrl + "/api/AnonimniKontakt";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processAnonimniKontaktAll(_response);
        });
    }

    protected processAnonimniKontaktAll(response: Response): Promise<Anonimni_kontakt[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Anonimni_kontakt.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonimni_kontakt[]>(null as any);
    }

    /**
     * @return OK
     */
    anonimniKontaktDELETE(id: number): Promise<Anonimni_kontakt> {
        let url_ = this.baseUrl + "/api/AnonimniKontakt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processAnonimniKontaktDELETE(_response);
        });
    }

    protected processAnonimniKontaktDELETE(response: Response): Promise<Anonimni_kontakt> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonimni_kontakt.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonimni_kontakt>(null as any);
    }

    /**
     * @return OK
     */
    artikliAll(): Promise<Artikl[]> {
        let url_ = this.baseUrl + "/api/Artikli";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processArtikliAll(_response);
        });
    }

    protected processArtikliAll(response: Response): Promise<Artikl[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Artikl.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Artikl[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    artikliPOST(body: Artikl | undefined): Promise<Artikl> {
        let url_ = this.baseUrl + "/api/Artikli";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processArtikliPOST(_response);
        });
    }

    protected processArtikliPOST(response: Response): Promise<Artikl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Artikl.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Artikl>(null as any);
    }

    /**
     * @return OK
     */
    artikliGET(id: number): Promise<Artikl> {
        let url_ = this.baseUrl + "/api/Artikli/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processArtikliGET(_response);
        });
    }

    protected processArtikliGET(response: Response): Promise<Artikl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Artikl.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Artikl>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    artikliPUT(id: number, body: Artikl | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Artikli/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processArtikliPUT(_response);
        });
    }

    protected processArtikliPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    artikliDELETE(id: number): Promise<Artikl> {
        let url_ = this.baseUrl + "/api/Artikli/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processArtikliDELETE(_response);
        });
    }

    protected processArtikliDELETE(response: Response): Promise<Artikl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Artikl.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Artikl>(null as any);
    }

    /**
     * @return OK
     */
    search(param: string): Promise<Artikl[]> {
        let url_ = this.baseUrl + "/api/Artikli/search/{param}";
        if (param === undefined || param === null)
            throw new globalThis.Error("The parameter 'param' must be defined.");
        url_ = url_.replace("{param}", encodeURIComponent("" + param));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Artikl[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Artikl.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Artikl[]>(null as any);
    }

    /**
     * @return OK
     */
    djelatnostiFirmeAll(): Promise<Djelatnost_firme[]> {
        let url_ = this.baseUrl + "/api/DjelatnostiFirme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDjelatnostiFirmeAll(_response);
        });
    }

    protected processDjelatnostiFirmeAll(response: Response): Promise<Djelatnost_firme[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Djelatnost_firme.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Djelatnost_firme[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    djelatnostiFirmePOST(body: Djelatnost_firme | undefined): Promise<Djelatnost_firme> {
        let url_ = this.baseUrl + "/api/DjelatnostiFirme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDjelatnostiFirmePOST(_response);
        });
    }

    protected processDjelatnostiFirmePOST(response: Response): Promise<Djelatnost_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Djelatnost_firme.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Djelatnost_firme>(null as any);
    }

    /**
     * @return OK
     */
    djelatnostiFirmeGET(id: number): Promise<Djelatnost_firme> {
        let url_ = this.baseUrl + "/api/DjelatnostiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDjelatnostiFirmeGET(_response);
        });
    }

    protected processDjelatnostiFirmeGET(response: Response): Promise<Djelatnost_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Djelatnost_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Djelatnost_firme>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    djelatnostiFirmePUT(id: number, body: Djelatnost_firme | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DjelatnostiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDjelatnostiFirmePUT(_response);
        });
    }

    protected processDjelatnostiFirmePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    djelatnostiFirmeDELETE(id: number): Promise<Djelatnost_firme> {
        let url_ = this.baseUrl + "/api/DjelatnostiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDjelatnostiFirmeDELETE(_response);
        });
    }

    protected processDjelatnostiFirmeDELETE(response: Response): Promise<Djelatnost_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Djelatnost_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Djelatnost_firme>(null as any);
    }

    /**
     * @return OK
     */
    drzaveAll(): Promise<Drzava[]> {
        let url_ = this.baseUrl + "/api/Drzave";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDrzaveAll(_response);
        });
    }

    protected processDrzaveAll(response: Response): Promise<Drzava[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Drzava.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drzava[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    drzavePOST(body: Drzava | undefined): Promise<Drzava> {
        let url_ = this.baseUrl + "/api/Drzave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDrzavePOST(_response);
        });
    }

    protected processDrzavePOST(response: Response): Promise<Drzava> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Drzava.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drzava>(null as any);
    }

    /**
     * @return OK
     */
    drzaveGET(id: number): Promise<Drzava> {
        let url_ = this.baseUrl + "/api/Drzave/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDrzaveGET(_response);
        });
    }

    protected processDrzaveGET(response: Response): Promise<Drzava> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Drzava.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drzava>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    drzavePUT(id: number, body: Drzava | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Drzave/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDrzavePUT(_response);
        });
    }

    protected processDrzavePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    drzaveDELETE(id: number): Promise<Drzava> {
        let url_ = this.baseUrl + "/api/Drzave/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processDrzaveDELETE(_response);
        });
    }

    protected processDrzaveDELETE(response: Response): Promise<Drzava> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Drzava.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drzava>(null as any);
    }

    /**
     * @return OK
     */
    search2(param: string): Promise<Drzava[]> {
        let url_ = this.baseUrl + "/api/Drzave/search/{param}";
        if (param === undefined || param === null)
            throw new globalThis.Error("The parameter 'param' must be defined.");
        url_ = url_.replace("{param}", encodeURIComponent("" + param));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSearch2(_response);
        });
    }

    protected processSearch2(response: Response): Promise<Drzava[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Drzava.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Drzava[]>(null as any);
    }

    /**
     * @param take (optional) 
     * @param skip (optional) 
     * @return OK
     */
    firmeAll(take: number | undefined, skip: number | undefined): Promise<Firma[]> {
        let url_ = this.baseUrl + "/api/Firme?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processFirmeAll(_response);
        });
    }

    protected processFirmeAll(response: Response): Promise<Firma[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Firma.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firma[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    firmePOST(body: Firma | undefined): Promise<Firma> {
        let url_ = this.baseUrl + "/api/Firme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processFirmePOST(_response);
        });
    }

    protected processFirmePOST(response: Response): Promise<Firma> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Firma.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firma>(null as any);
    }

    /**
     * @return OK
     */
    poslovniImenik(): Promise<PoslovniImenik[]> {
        let url_ = this.baseUrl + "/api/Firme/PoslovniImenik";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPoslovniImenik(_response);
        });
    }

    protected processPoslovniImenik(response: Response): Promise<PoslovniImenik[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PoslovniImenik.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoslovniImenik[]>(null as any);
    }

    /**
     * @return OK
     */
    firmeGET(id: number): Promise<Firma> {
        let url_ = this.baseUrl + "/api/Firme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processFirmeGET(_response);
        });
    }

    protected processFirmeGET(response: Response): Promise<Firma> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Firma.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firma>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    firmePUT(id: number, body: Firma | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Firme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processFirmePUT(_response);
        });
    }

    protected processFirmePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    firmeDELETE(id: number): Promise<Firma> {
        let url_ = this.baseUrl + "/api/Firme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processFirmeDELETE(_response);
        });
    }

    protected processFirmeDELETE(response: Response): Promise<Firma> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Firma.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firma>(null as any);
    }

    /**
     * @return OK
     */
    search3(param: string): Promise<Firma[]> {
        let url_ = this.baseUrl + "/api/Firme/search/{param}";
        if (param === undefined || param === null)
            throw new globalThis.Error("The parameter 'param' must be defined.");
        url_ = url_.replace("{param}", encodeURIComponent("" + param));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSearch3(_response);
        });
    }

    protected processSearch3(response: Response): Promise<Firma[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Firma.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Firma[]>(null as any);
    }

    /**
     * @return OK
     */
    istek(): Promise<{ [key: string]: Date; }> {
        let url_ = this.baseUrl + "/api/Firme/istek";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processIstek(_response);
        });
    }

    protected processIstek(response: Response): Promise<{ [key: string]: Date; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {} as any;
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            (result200 as any)![key] = resultData200[key] ? new Date(resultData200[key].toString()) : null as any;
                    }
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Date; }>(null as any);
    }

    /**
     * @return OK
     */
    gradoviAll(): Promise<Grad[]> {
        let url_ = this.baseUrl + "/api/Gradovi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processGradoviAll(_response);
        });
    }

    protected processGradoviAll(response: Response): Promise<Grad[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Grad.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grad[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    gradoviPOST(body: Grad | undefined): Promise<Grad> {
        let url_ = this.baseUrl + "/api/Gradovi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processGradoviPOST(_response);
        });
    }

    protected processGradoviPOST(response: Response): Promise<Grad> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Grad.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grad>(null as any);
    }

    /**
     * @return OK
     */
    gradoviGET(id: number): Promise<Grad> {
        let url_ = this.baseUrl + "/api/Gradovi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processGradoviGET(_response);
        });
    }

    protected processGradoviGET(response: Response): Promise<Grad> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Grad.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grad>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    gradoviPUT(id: number, body: Grad | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Gradovi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processGradoviPUT(_response);
        });
    }

    protected processGradoviPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    gradoviDELETE(id: number): Promise<Grad> {
        let url_ = this.baseUrl + "/api/Gradovi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processGradoviDELETE(_response);
        });
    }

    protected processGradoviDELETE(response: Response): Promise<Grad> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Grad.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Grad>(null as any);
    }

    /**
     * @return OK
     */
    ipAll(): Promise<Iplog[]> {
        let url_ = this.baseUrl + "/api/Ip";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processIpAll(_response);
        });
    }

    protected processIpAll(response: Response): Promise<Iplog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Iplog.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Iplog[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ip(body: Iplog | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processIp(_response);
        });
    }

    protected processIp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    jediniceMjereAll(): Promise<Jedinica_mjere[]> {
        let url_ = this.baseUrl + "/api/JediniceMjere";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processJediniceMjereAll(_response);
        });
    }

    protected processJediniceMjereAll(response: Response): Promise<Jedinica_mjere[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Jedinica_mjere.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Jedinica_mjere[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    jediniceMjerePOST(body: Jedinica_mjere | undefined): Promise<Jedinica_mjere> {
        let url_ = this.baseUrl + "/api/JediniceMjere";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processJediniceMjerePOST(_response);
        });
    }

    protected processJediniceMjerePOST(response: Response): Promise<Jedinica_mjere> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Jedinica_mjere.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Jedinica_mjere>(null as any);
    }

    /**
     * @return OK
     */
    jediniceMjereGET(id: number): Promise<Jedinica_mjere> {
        let url_ = this.baseUrl + "/api/JediniceMjere/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processJediniceMjereGET(_response);
        });
    }

    protected processJediniceMjereGET(response: Response): Promise<Jedinica_mjere> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Jedinica_mjere.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Jedinica_mjere>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    jediniceMjerePUT(id: number, body: Jedinica_mjere | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/JediniceMjere/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processJediniceMjerePUT(_response);
        });
    }

    protected processJediniceMjerePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    jediniceMjereDELETE(id: number): Promise<Jedinica_mjere> {
        let url_ = this.baseUrl + "/api/JediniceMjere/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processJediniceMjereDELETE(_response);
        });
    }

    protected processJediniceMjereDELETE(response: Response): Promise<Jedinica_mjere> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Jedinica_mjere.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Jedinica_mjere>(null as any);
    }

    /**
     * @return OK
     */
    komentariAll(id: number): Promise<Komentar[]> {
        let url_ = this.baseUrl + "/api/Komentari/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKomentariAll(_response);
        });
    }

    protected processKomentariAll(response: Response): Promise<Komentar[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Komentar.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Komentar[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    komentariPUT(id: number, body: Komentar | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Komentari/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKomentariPUT(_response);
        });
    }

    protected processKomentariPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    komentariDELETE(id: number): Promise<Komentar> {
        let url_ = this.baseUrl + "/api/Komentari/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKomentariDELETE(_response);
        });
    }

    protected processKomentariDELETE(response: Response): Promise<Komentar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Komentar.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Komentar>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    komentariPOST(body: Komentar | undefined): Promise<Komentar> {
        let url_ = this.baseUrl + "/api/Komentari";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKomentariPOST(_response);
        });
    }

    protected processKomentariPOST(response: Response): Promise<Komentar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Komentar.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Komentar>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    kontaktPOST(body: Kontakt | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Kontakt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKontaktPOST(_response);
        });
    }

    protected processKontaktPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    kontaktAll(): Promise<Kontakt[]> {
        let url_ = this.baseUrl + "/api/Kontakt";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKontaktAll(_response);
        });
    }

    protected processKontaktAll(response: Response): Promise<Kontakt[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Kontakt.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kontakt[]>(null as any);
    }

    /**
     * @return OK
     */
    kontaktDELETE(id: number): Promise<Kontakt> {
        let url_ = this.baseUrl + "/api/Kontakt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKontaktDELETE(_response);
        });
    }

    protected processKontaktDELETE(response: Response): Promise<Kontakt> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Kontakt.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kontakt>(null as any);
    }

    /**
     * @return OK
     */
    ino(dateFrom: Date, dateTo: Date, artikal: number): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Ino/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processIno(_response);
        });
    }

    /**
     * @return OK
     */
    ino2(dateFrom: Date, dateTo: Date, artikal: number, opisi?: number[]): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Ino2/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));

        // Add opisi as query parameter if provided
        if (opisi !== undefined && opisi !== null && opisi.length > 0) {
            url_ += "?opisi=" + encodeURIComponent(opisi.join(','));
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processIno(_response);
        });
    }

    protected processIno(response: Response): Promise<KretanjeCijena> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KretanjeCijena.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KretanjeCijena>(null as any);
    }

    /**
     * @return OK
     */
    hrv(dateFrom: Date, dateTo: Date, artikal: number): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Hrv/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrv(_response);
        });
    }

    /**
     * @return OK
     */
    hrv2(dateFrom: Date, dateTo: Date, artikal: number, opisi?: number[]): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Hrv2/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));

        // Add opisi as query parameter if provided
        if (opisi !== undefined && opisi !== null && opisi.length > 0) {
            url_ += "?opisi=" + encodeURIComponent(opisi.join(','));
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrv(_response);
        });
    }

    protected processHrv(response: Response): Promise<KretanjeCijena> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KretanjeCijena.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KretanjeCijena>(null as any);
    }

    /**
     * @return OK
     */
    srb(dateFrom: Date, dateTo: Date, artikal: number): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Srb/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrb(_response);
        });
    }

    /**
     * @return OK
     */
    srb2(dateFrom: Date, dateTo: Date, artikal: number, opisi?: number[]): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/Srb2/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));

        // Add opisi as query parameter if provided
        if (opisi !== undefined && opisi !== null && opisi.length > 0) {
            url_ += "?opisi=" + encodeURIComponent(opisi.join(','));
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrb(_response);
        });
    }

    protected processSrb(response: Response): Promise<KretanjeCijena> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KretanjeCijena.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KretanjeCijena>(null as any);
    }

    /**
     * @return OK
     */
    biH(dateFrom: Date, dateTo: Date, artikal: number): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/BiH/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiH(_response);
        });
    }

    /**
     * @return OK
     */
    biH2(dateFrom: Date, dateTo: Date, artikal: number, opisi?: number[]): Promise<KretanjeCijena> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/BiH2/{dateFrom}/{dateTo}/{artikal}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (artikal === undefined || artikal === null)
            throw new globalThis.Error("The parameter 'artikal' must be defined.");
        url_ = url_.replace("{artikal}", encodeURIComponent("" + artikal));

        // Add opisi as query parameter if provided
        if (opisi !== undefined && opisi !== null && opisi.length > 0) {
            url_ += "?opisi=" + encodeURIComponent(opisi.join(','));
        }

        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiH(_response);
        });
    }

    protected processBiH(response: Response): Promise<KretanjeCijena> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = KretanjeCijena.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KretanjeCijena>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    async generatePdf(drzava: string, dateFrom: Date, dateTo: Date, body: PdfInput[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/KretanjeCijena/GeneratePdf/{drzava}/{dateFrom}/{dateTo}";
        if (drzava === undefined || drzava === null)
            throw new globalThis.Error("The parameter 'drzava' must be defined.");
        url_ = url_.replace("{drzava}", encodeURIComponent("" + drzava));
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        const response = await firstValueFrom(this.http.post(url_, content_, {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            }),
            responseType: 'blob',
            observe: 'response'
        } as any));

        return this.processGeneratePdf(response as any);
    }

    protected processGeneratePdf(response: HttpResponse<Blob>): Promise<FileResponse> {
        const status = response.status;

        if (status === 200) {
            return Promise.resolve({
                data: response.body as any,
                status: status,
                fileName: this.getFileNameFromResponse(response),
                headers: response.headers
            });
        } else if (status !== 200 && status !== 204) {
            return response.body?.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, response.headers);
            }) ?? Promise.reject(new Error("No response body"));
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    private getFileNameFromResponse(response: HttpResponse<Blob>): string {
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (fileNameMatch && fileNameMatch[1]) {
                return fileNameMatch[1].replace(/['"]/g, '');
            }
        }
        return 'download.pdf';
    }

    /**
     * @return OK
     */
    kursEuraAll(dateFrom: Date, dateTo: Date): Promise<Kurs_eura[]> {
        let url_ = this.baseUrl + "/api/KursEura/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKursEuraAll(_response);
        });
    }

    protected processKursEuraAll(response: Response): Promise<Kurs_eura[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Kurs_eura.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kurs_eura[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    kursEuraPOST(body: Kurs_eura | undefined): Promise<Kurs_eura> {
        let url_ = this.baseUrl + "/api/KursEura";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKursEuraPOST(_response);
        });
    }

    protected processKursEuraPOST(response: Response): Promise<Kurs_eura> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Kurs_eura.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kurs_eura>(null as any);
    }

    /**
     * @return OK
     */
    kursEuraDELETE(id: number): Promise<Kurs_eura> {
        let url_ = this.baseUrl + "/api/KursEura/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processKursEuraDELETE(_response);
        });
    }

    protected processKursEuraDELETE(response: Response): Promise<Kurs_eura> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Kurs_eura.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kurs_eura>(null as any);
    }

    /**
     * @return OK
     */
    loginsAll(): Promise<any[]> {
        console.log("Fetching all logins");
        let url_ = this.baseUrl + "/api/Logins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLoginsAll(_response);
        });
    }

    // In your LoginsClient service
    async loginsAllDirect(): Promise<any[]> {
        console.log("Fetching logins directly");
        const url = this.baseUrl + "/api/Logins";

        try {
            const response = await firstValueFrom(
                this.http.get<any[]>(url, {
                    headers: { 'Accept': 'application/json' }
                })
            );
            console.log("Direct request successful, records:", response.length);
            return response;
        } catch (error) {
            console.error("Direct request failed:", error);
            throw error;
        }
    }

    protected processLoginsAll(response: Response): Promise<any[]> {
        console.log(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    loginsPOST(body: Login | undefined): Promise<Login> {
        let url_ = this.baseUrl + "/api/Logins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLoginsPOST(_response);
        });
    }

    protected processLoginsPOST(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Login.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    /**
     * @return OK
     */
    loginsGET(id: number): Promise<Login> {
        let url_ = this.baseUrl + "/api/Logins/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLoginsGET(_response);
        });
    }

    protected processLoginsGET(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Login.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    loginsPUT(id: number, body: Login | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Logins/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLoginsPUT(_response);
        });
    }

    protected processLoginsPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    loginsDELETE(id: number): Promise<Login> {
        let url_ = this.baseUrl + "/api/Logins/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLoginsDELETE(_response);
        });
    }

    protected processLoginsDELETE(response: Response): Promise<Login> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Login.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    login(body: Login | undefined): Promise<LoginExtendedModel> {
        let url_ = this.baseUrl + "/api/Logins/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginExtendedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginExtendedModel.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginExtendedModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    mobile(body: MobileLogin | undefined): Promise<LoginExtendedModel> {
        let url_ = this.baseUrl + "/api/Logins/mobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processMobile(_response);
        });
    }

    protected processMobile(response: Response): Promise<LoginExtendedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginExtendedModel.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginExtendedModel>(null as any);
    }

    /**
     * @return OK
     */
    search4(param: string): Promise<Login[]> {
        let url_ = this.baseUrl + "/api/Logins/search/{param}";
        if (param === undefined || param === null)
            throw new globalThis.Error("The parameter 'param' must be defined.");
        url_ = url_.replace("{param}", encodeURIComponent("" + param));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSearch4(_response);
        });
    }

    protected processSearch4(response: Response): Promise<Login[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Login.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Login[]>(null as any);
    }

    /**
     * @return OK
     */
    logout(userID: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Logins/mobile/logout/{userID}";
        if (userID === undefined || userID === null)
            throw new globalThis.Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refresh(body: MobileLogin | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Logins/mobile/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    menuAll(): Promise<MenuCountResult[]> {
        let url_ = this.baseUrl + "/api/Menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processMenuAll(_response);
        });
    }

    protected processMenuAll(response: Response): Promise<MenuCountResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(MenuCountResult.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuCountResult[]>(null as any);
    }

    /**
     * @return OK
     */
    menu(type: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Menu/{type}";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processMenu(_response);
        });
    }

    protected processMenu(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    refreshCache(): Promise<MenuCountResult[]> {
        let url_ = this.baseUrl + "/api/Menu/RefreshCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRefreshCache(_response);
        });
    }

    protected processRefreshCache(response: Response): Promise<MenuCountResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(MenuCountResult.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuCountResult[]>(null as any);
    }

    /**
     * @return OK
     */
    nudjeneCijeneAll(dateFrom: Date, dateTo: Date): Promise<Nudjene_cijene[]> {
        let url_ = this.baseUrl + "/api/NudjeneCijene/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processNudjeneCijeneAll(_response);
        });
    }

    protected processNudjeneCijeneAll(response: Response): Promise<Nudjene_cijene[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Nudjene_cijene.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Nudjene_cijene[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    nudjeneCijenePOST(body: Nudjene_cijene | undefined): Promise<Nudjene_cijene> {
        let url_ = this.baseUrl + "/api/NudjeneCijene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processNudjeneCijenePOST(_response);
        });
    }

    protected processNudjeneCijenePOST(response: Response): Promise<Nudjene_cijene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Nudjene_cijene.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Nudjene_cijene>(null as any);
    }

    /**
     * @return OK
     */
    nudjeneCijeneDELETE(id: number): Promise<Nudjene_cijene> {
        let url_ = this.baseUrl + "/api/NudjeneCijene/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processNudjeneCijeneDELETE(_response);
        });
    }

    protected processNudjeneCijeneDELETE(response: Response): Promise<Nudjene_cijene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Nudjene_cijene.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Nudjene_cijene>(null as any);
    }

    /**
     * @return OK
     */
    obavjestenjaAll(): Promise<Obavjestenje[]> {
        let url_ = this.baseUrl + "/api/Obavjestenja";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processObavjestenjaAll(_response);
        });
    }

    protected processObavjestenjaAll(response: Response): Promise<Obavjestenje[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Obavjestenje.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Obavjestenje[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    obavjestenjaPOST(body: Obavjestenje | undefined): Promise<Obavjestenje> {
        let url_ = this.baseUrl + "/api/Obavjestenja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processObavjestenjaPOST(_response);
        });
    }

    protected processObavjestenjaPOST(response: Response): Promise<Obavjestenje> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Obavjestenje.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Obavjestenje>(null as any);
    }

    /**
     * @return OK
     */
    obavjestenjaAll2(id: number): Promise<Obavjestenje[]> {
        let url_ = this.baseUrl + "/api/Obavjestenja/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processObavjestenjaAll2(_response);
        });
    }

    protected processObavjestenjaAll2(response: Response): Promise<Obavjestenje[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Obavjestenje.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Obavjestenje[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    obavjestenjaPUT(id: number, body: Obavjestenje | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Obavjestenja/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processObavjestenjaPUT(_response);
        });
    }

    protected processObavjestenjaPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    obavjestenjaDELETE(id: number): Promise<Obavjestenje> {
        let url_ = this.baseUrl + "/api/Obavjestenja/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processObavjestenjaDELETE(_response);
        });
    }

    protected processObavjestenjaDELETE(response: Response): Promise<Obavjestenje> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Obavjestenje.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Obavjestenje>(null as any);
    }

    /**
     * @return OK
     */
    oblastiFirmeAll(): Promise<Oblast_firme[]> {
        let url_ = this.baseUrl + "/api/OblastiFirme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOblastiFirmeAll(_response);
        });
    }

    protected processOblastiFirmeAll(response: Response): Promise<Oblast_firme[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Oblast_firme.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Oblast_firme[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    oblastiFirmePOST(body: Oblast_firme | undefined): Promise<Oblast_firme> {
        let url_ = this.baseUrl + "/api/OblastiFirme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOblastiFirmePOST(_response);
        });
    }

    protected processOblastiFirmePOST(response: Response): Promise<Oblast_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Oblast_firme.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Oblast_firme>(null as any);
    }

    /**
     * @return OK
     */
    oblastiFirmeGET(id: number): Promise<Oblast_firme> {
        let url_ = this.baseUrl + "/api/OblastiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOblastiFirmeGET(_response);
        });
    }

    protected processOblastiFirmeGET(response: Response): Promise<Oblast_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Oblast_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Oblast_firme>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    oblastiFirmePUT(id: number, body: Oblast_firme | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OblastiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOblastiFirmePUT(_response);
        });
    }

    protected processOblastiFirmePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    oblastiFirmeDELETE(id: number): Promise<Oblast_firme> {
        let url_ = this.baseUrl + "/api/OblastiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOblastiFirmeDELETE(_response);
        });
    }

    protected processOblastiFirmeDELETE(response: Response): Promise<Oblast_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Oblast_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Oblast_firme>(null as any);
    }

    /**
     * @return OK
     */
    opisiAll(): Promise<Opi[]> {
        let url_ = this.baseUrl + "/api/Opisi";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOpisiAll(_response);
        });
    }

    protected processOpisiAll(response: Response): Promise<Opi[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Opi.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Opi[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    opisiPOST(body: Opi | undefined): Promise<Opi> {
        let url_ = this.baseUrl + "/api/Opisi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOpisiPOST(_response);
        });
    }

    protected processOpisiPOST(response: Response): Promise<Opi> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Opi.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Opi>(null as any);
    }

    /**
     * @return OK
     */
    opisiGET(id: number): Promise<Opi> {
        let url_ = this.baseUrl + "/api/Opisi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOpisiGET(_response);
        });
    }

    protected processOpisiGET(response: Response): Promise<Opi> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Opi.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Opi>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    opisiPUT(id: number, body: Opi | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Opisi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOpisiPUT(_response);
        });
    }

    protected processOpisiPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    opisiDELETE(id: number): Promise<Opi> {
        let url_ = this.baseUrl + "/api/Opisi/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOpisiDELETE(_response);
        });
    }

    protected processOpisiDELETE(response: Response): Promise<Opi> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Opi.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Opi>(null as any);
    }

    /**
     * @return OK
     */
    otkupneCijeneAll(dateFrom: Date, dateTo: Date): Promise<Otkupne_cijene[]> {
        let url_ = this.baseUrl + "/api/OtkupneCijene/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOtkupneCijeneAll(_response);
        });
    }

    protected processOtkupneCijeneAll(response: Response): Promise<Otkupne_cijene[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Otkupne_cijene.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Otkupne_cijene[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    otkupneCijenePOST(body: Otkupne_cijene | undefined): Promise<Otkupne_cijene> {
        let url_ = this.baseUrl + "/api/OtkupneCijene";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOtkupneCijenePOST(_response);
        });
    }

    protected processOtkupneCijenePOST(response: Response): Promise<Otkupne_cijene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Otkupne_cijene.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Otkupne_cijene>(null as any);
    }

    /**
     * @return OK
     */
    otkupneCijeneDELETE(id: number): Promise<Otkupne_cijene> {
        let url_ = this.baseUrl + "/api/OtkupneCijene/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processOtkupneCijeneDELETE(_response);
        });
    }

    protected processOtkupneCijeneDELETE(response: Response): Promise<Otkupne_cijene> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Otkupne_cijene.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Otkupne_cijene>(null as any);
    }

    /**
     * @return OK
     */
    permissionsAll(): Promise<Permission[]> {
        let url_ = this.baseUrl + "/api/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPermissionsAll(_response);
        });
    }

    protected processPermissionsAll(response: Response): Promise<Permission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Permission.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission[]>(null as any);
    }

    /**
     * @return OK
     */
    permissionsGET(id: string): Promise<Permission> {
        let url_ = this.baseUrl + "/api/Permissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPermissionsGET(_response);
        });
    }

    protected processPermissionsGET(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Permission.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    permissionsPUT(id: string, body: Permission | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPermissionsPUT(_response);
        });
    }

    protected processPermissionsPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    count(date: Date): Promise<number> {
        let url_ = this.baseUrl + "/api/Ponude/Count/{date}";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    count2(date: Date, artikl: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Ponude/Count/{date}/{artikl}";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        if (artikl === undefined || artikl === null)
            throw new globalThis.Error("The parameter 'artikl' must be defined.");
        url_ = url_.replace("{artikl}", encodeURIComponent("" + artikl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processCount2(_response);
        });
    }

    protected processCount2(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    biHAll(dateFrom: Date, dateTo: Date): Promise<Javna_ponudum[]> {
        let url_ = this.baseUrl + "/api/Ponude/BiH/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiHAll(_response);
        });
    }

    protected processBiHAll(response: Response): Promise<Javna_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    srbAll(dateFrom: Date, dateTo: Date): Promise<Javna_ponudum[]> {
        let url_ = this.baseUrl + "/api/Ponude/Srb/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrbAll(_response);
        });
    }

    protected processSrbAll(response: Response): Promise<Javna_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    hrvAll(dateFrom: Date, dateTo: Date): Promise<Javna_ponudum[]> {
        let url_ = this.baseUrl + "/api/Ponude/Hrv/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrvAll(_response);
        });
    }

    protected processHrvAll(response: Response): Promise<Javna_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    inoAll(dateFrom: Date, dateTo: Date): Promise<Javna_ponudum[]> {
        let url_ = this.baseUrl + "/api/Ponude/Ino/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processInoAll(_response);
        });
    }

    protected processInoAll(response: Response): Promise<Javna_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    ponudeAll(idFirme: number): Promise<Javna_ponudum[]> {
        let url_ = this.baseUrl + "/api/Ponude/{idFirme}";
        if (idFirme === undefined || idFirme === null)
            throw new globalThis.Error("The parameter 'idFirme' must be defined.");
        url_ = url_.replace("{idFirme}", encodeURIComponent("" + idFirme));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPonudeAll(_response);
        });
    }

    protected processPonudeAll(response: Response): Promise<Javna_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    ponudeGET(id: number): Promise<Javna_ponudum> {
        let url_ = this.baseUrl + "/api/Ponude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPonudeGET(_response);
        });
    }

    protected processPonudeGET(response: Response): Promise<Javna_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Javna_ponudum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    ponudePUT(id: number, body: Javna_ponudum | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ponude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPonudePUT(_response);
        });
    }

    protected processPonudePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    ponudeDELETE(id: number): Promise<Javna_ponudum> {
        let url_ = this.baseUrl + "/api/Ponude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPonudeDELETE(_response);
        });
    }

    protected processPonudeDELETE(response: Response): Promise<Javna_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Javna_ponudum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    ponudePOST(body: Javna_ponudum | undefined): Promise<Javna_ponudum> {
        let url_ = this.baseUrl + "/api/Ponude";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPonudePOST(_response);
        });
    }

    protected processPonudePOST(response: Response): Promise<Javna_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Javna_ponudum.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_ponudum>(null as any);
    }

    /**
     * @return OK
     */
    count3(date: Date): Promise<number> {
        let url_ = this.baseUrl + "/api/Potraznje/Count/{date}";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processCount3(_response);
        });
    }

    protected processCount3(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    count4(date: Date, artikl: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Potraznje/Count/{date}/{artikl}";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        if (artikl === undefined || artikl === null)
            throw new globalThis.Error("The parameter 'artikl' must be defined.");
        url_ = url_.replace("{artikl}", encodeURIComponent("" + artikl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processCount4(_response);
        });
    }

    protected processCount4(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    biHAll2(dateFrom: Date, dateTo: Date): Promise<Javna_potraznja[]> {
        let url_ = this.baseUrl + "/api/Potraznje/BiH/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiHAll2(_response);
        });
    }

    protected processBiHAll2(response: Response): Promise<Javna_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    srbAll2(dateFrom: Date, dateTo: Date): Promise<Javna_potraznja[]> {
        let url_ = this.baseUrl + "/api/Potraznje/Srb/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrbAll2(_response);
        });
    }

    protected processSrbAll2(response: Response): Promise<Javna_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    hrvAll2(dateFrom: Date, dateTo: Date): Promise<Javna_potraznja[]> {
        let url_ = this.baseUrl + "/api/Potraznje/Hrv/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrvAll2(_response);
        });
    }

    protected processHrvAll2(response: Response): Promise<Javna_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    inoAll2(dateFrom: Date, dateTo: Date): Promise<Javna_potraznja[]> {
        let url_ = this.baseUrl + "/api/Potraznje/Ino/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processInoAll2(_response);
        });
    }

    protected processInoAll2(response: Response): Promise<Javna_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    potraznjeAll(idFirme: number): Promise<Javna_potraznja[]> {
        let url_ = this.baseUrl + "/api/Potraznje/{idFirme}";
        if (idFirme === undefined || idFirme === null)
            throw new globalThis.Error("The parameter 'idFirme' must be defined.");
        url_ = url_.replace("{idFirme}", encodeURIComponent("" + idFirme));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPotraznjeAll(_response);
        });
    }

    protected processPotraznjeAll(response: Response): Promise<Javna_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Javna_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    potraznjeGET(id: number): Promise<Javna_potraznja> {
        let url_ = this.baseUrl + "/api/Potraznje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPotraznjeGET(_response);
        });
    }

    protected processPotraznjeGET(response: Response): Promise<Javna_potraznja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Javna_potraznja.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    potraznjePUT(id: number, body: Javna_potraznja | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Potraznje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPotraznjePUT(_response);
        });
    }

    protected processPotraznjePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    potraznjeDELETE(id: number): Promise<Javna_potraznja> {
        let url_ = this.baseUrl + "/api/Potraznje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPotraznjeDELETE(_response);
        });
    }

    protected processPotraznjeDELETE(response: Response): Promise<Javna_potraznja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Javna_potraznja.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    potraznjePOST(body: Javna_potraznja | undefined): Promise<Javna_potraznja> {
        let url_ = this.baseUrl + "/api/Potraznje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processPotraznjePOST(_response);
        });
    }

    protected processPotraznjePOST(response: Response): Promise<Javna_potraznja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Javna_potraznja.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Javna_potraznja>(null as any);
    }

    /**
     * @return OK
     */
    realizacijeAll(dateFrom: Date, dateTo: Date): Promise<Realizacije[]> {
        let url_ = this.baseUrl + "/api/Realizacije/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRealizacijeAll(_response);
        });
    }

    protected processRealizacijeAll(response: Response): Promise<Realizacije[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Realizacije.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Realizacije[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    realizacijePOST(body: Realizacije | undefined): Promise<Realizacije> {
        let url_ = this.baseUrl + "/api/Realizacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRealizacijePOST(_response);
        });
    }

    protected processRealizacijePOST(response: Response): Promise<Realizacije> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Realizacije.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Realizacije>(null as any);
    }

    /**
     * @return OK
     */
    realizacijeDELETE(id: number): Promise<Realizacije> {
        let url_ = this.baseUrl + "/api/Realizacije/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRealizacijeDELETE(_response);
        });
    }

    protected processRealizacijeDELETE(response: Response): Promise<Realizacije> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Realizacije.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Realizacije>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registrovaniiKontaktPOST(body: Reg_kontakt | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/RegistrovaniiKontakt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRegistrovaniiKontaktPOST(_response);
        });
    }

    protected processRegistrovaniiKontaktPOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    registrovaniiKontaktAll(): Promise<Reg_kontakt[]> {
        let url_ = this.baseUrl + "/api/RegistrovaniiKontakt";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRegistrovaniiKontaktAll(_response);
        });
    }

    protected processRegistrovaniiKontaktAll(response: Response): Promise<Reg_kontakt[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Reg_kontakt.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Reg_kontakt[]>(null as any);
    }

    /**
     * @return OK
     */
    registrovaniiKontaktDELETE(id: number): Promise<Reg_kontakt> {
        let url_ = this.baseUrl + "/api/RegistrovaniiKontakt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processRegistrovaniiKontaktDELETE(_response);
        });
    }

    protected processRegistrovaniiKontaktDELETE(response: Response): Promise<Reg_kontakt> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Reg_kontakt.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Reg_kontakt>(null as any);
    }

    /**
     * @return OK
     */
    biHAll3(dateFrom: Date, dateTo: Date): Promise<Sms_ponudum[]> {
        let url_ = this.baseUrl + "/api/SmsPonude/BiH/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiHAll3(_response);
        });
    }

    protected processBiHAll3(response: Response): Promise<Sms_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    inoAll3(dateFrom: Date, dateTo: Date): Promise<Sms_ponudum[]> {
        let url_ = this.baseUrl + "/api/SmsPonude/Ino/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processInoAll3(_response);
        });
    }

    protected processInoAll3(response: Response): Promise<Sms_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    srbAll3(dateFrom: Date, dateTo: Date): Promise<Sms_ponudum[]> {
        let url_ = this.baseUrl + "/api/SmsPonude/Srb/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrbAll3(_response);
        });
    }

    protected processSrbAll3(response: Response): Promise<Sms_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    hrvAll3(dateFrom: Date, dateTo: Date): Promise<Sms_ponudum[]> {
        let url_ = this.baseUrl + "/api/SmsPonude/Hrv/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrvAll3(_response);
        });
    }

    protected processHrvAll3(response: Response): Promise<Sms_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    smsPonudePOST(body: Sms_ponudum | undefined): Promise<Sms_ponudum> {
        let url_ = this.baseUrl + "/api/SmsPonude";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsPonudePOST(_response);
        });
    }

    protected processSmsPonudePOST(response: Response): Promise<Sms_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Sms_ponudum.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum>(null as any);
    }

    /**
     * @return OK
     */
    smsPonudeDELETE(id: number): Promise<Sms_ponudum> {
        let url_ = this.baseUrl + "/api/SmsPonude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsPonudeDELETE(_response);
        });
    }

    protected processSmsPonudeDELETE(response: Response): Promise<Sms_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Sms_ponudum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_ponudum>(null as any);
    }

    /**
     * @return OK
     */
    biHAll4(dateFrom: Date, dateTo: Date): Promise<Sms_potraznja[]> {
        let url_ = this.baseUrl + "/api/SmsPotraznje/BiH/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processBiHAll4(_response);
        });
    }

    protected processBiHAll4(response: Response): Promise<Sms_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    inoAll4(dateFrom: Date, dateTo: Date): Promise<Sms_potraznja[]> {
        let url_ = this.baseUrl + "/api/SmsPotraznje/Ino/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processInoAll4(_response);
        });
    }

    protected processInoAll4(response: Response): Promise<Sms_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    srbAll4(dateFrom: Date, dateTo: Date): Promise<Sms_potraznja[]> {
        let url_ = this.baseUrl + "/api/SmsPotraznje/Srb/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSrbAll4(_response);
        });
    }

    protected processSrbAll4(response: Response): Promise<Sms_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja[]>(null as any);
    }

    /**
     * @return OK
     */
    hrvAll4(dateFrom: Date, dateTo: Date): Promise<Sms_potraznja[]> {
        let url_ = this.baseUrl + "/api/SmsPotraznje/Hrv/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processHrvAll4(_response);
        });
    }

    protected processHrvAll4(response: Response): Promise<Sms_potraznja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_potraznja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    smsPotraznjePOST(body: Sms_potraznja | undefined): Promise<Sms_potraznja> {
        let url_ = this.baseUrl + "/api/SmsPotraznje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsPotraznjePOST(_response);
        });
    }

    protected processSmsPotraznjePOST(response: Response): Promise<Sms_potraznja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Sms_potraznja.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja>(null as any);
    }

    /**
     * @return OK
     */
    smsPotraznjeDELETE(id: number): Promise<Sms_potraznja> {
        let url_ = this.baseUrl + "/api/SmsPotraznje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsPotraznjeDELETE(_response);
        });
    }

    protected processSmsPotraznjeDELETE(response: Response): Promise<Sms_potraznja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Sms_potraznja.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_potraznja>(null as any);
    }

    /**
     * @return OK
     */
    smsSortsAll(id: number): Promise<Sms_sort[]> {
        let url_ = this.baseUrl + "/api/SmsSorts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsSortsAll(_response);
        });
    }

    protected processSmsSortsAll(response: Response): Promise<Sms_sort[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Sms_sort.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_sort[]>(null as any);
    }

    /**
     * @return OK
     */
    smsSortsDELETE(id: number): Promise<Sms_sort> {
        let url_ = this.baseUrl + "/api/SmsSorts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsSortsDELETE(_response);
        });
    }

    protected processSmsSortsDELETE(response: Response): Promise<Sms_sort> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Sms_sort.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_sort>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    smsSortsPOST(body: Sms_sort | undefined): Promise<Sms_sort> {
        let url_ = this.baseUrl + "/api/SmsSorts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processSmsSortsPOST(_response);
        });
    }

    protected processSmsSortsPOST(response: Response): Promise<Sms_sort> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Sms_sort.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sms_sort>(null as any);
    }

    /**
     * @return OK
     */
    statusiFirmeAll(): Promise<Status_firme[]> {
        let url_ = this.baseUrl + "/api/StatusiFirme";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processStatusiFirmeAll(_response);
        });
    }

    protected processStatusiFirmeAll(response: Response): Promise<Status_firme[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Status_firme.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status_firme[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    statusiFirmePOST(body: Status_firme | undefined): Promise<Status_firme> {
        let url_ = this.baseUrl + "/api/StatusiFirme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processStatusiFirmePOST(_response);
        });
    }

    protected processStatusiFirmePOST(response: Response): Promise<Status_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Status_firme.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status_firme>(null as any);
    }

    /**
     * @return OK
     */
    statusiFirmeGET(id: number): Promise<Status_firme> {
        let url_ = this.baseUrl + "/api/StatusiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processStatusiFirmeGET(_response);
        });
    }

    protected processStatusiFirmeGET(response: Response): Promise<Status_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Status_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status_firme>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    statusiFirmePUT(id: number, body: Status_firme | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StatusiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processStatusiFirmePUT(_response);
        });
    }

    protected processStatusiFirmePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    statusiFirmeDELETE(id: number): Promise<Status_firme> {
        let url_ = this.baseUrl + "/api/StatusiFirme/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processStatusiFirmeDELETE(_response);
        });
    }

    protected processStatusiFirmeDELETE(response: Response): Promise<Status_firme> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Status_firme.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status_firme>(null as any);
    }

    /**
     * @return OK
     */
    tipoviNadogradnjeAll(): Promise<Tip_nadogradnje[]> {
        let url_ = this.baseUrl + "/api/TipoviNadogradnje";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviNadogradnjeAll(_response);
        });
    }

    protected processTipoviNadogradnjeAll(response: Response): Promise<Tip_nadogradnje[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Tip_nadogradnje.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_nadogradnje[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    tipoviNadogradnjePOST(body: Tip_nadogradnje | undefined): Promise<Tip_nadogradnje> {
        let url_ = this.baseUrl + "/api/TipoviNadogradnje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviNadogradnjePOST(_response);
        });
    }

    protected processTipoviNadogradnjePOST(response: Response): Promise<Tip_nadogradnje> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Tip_nadogradnje.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_nadogradnje>(null as any);
    }

    /**
     * @return OK
     */
    tipoviNadogradnjeGET(id: number): Promise<Tip_nadogradnje> {
        let url_ = this.baseUrl + "/api/TipoviNadogradnje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviNadogradnjeGET(_response);
        });
    }

    protected processTipoviNadogradnjeGET(response: Response): Promise<Tip_nadogradnje> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Tip_nadogradnje.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_nadogradnje>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    tipoviNadogradnjePUT(id: number, body: Tip_nadogradnje | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TipoviNadogradnje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviNadogradnjePUT(_response);
        });
    }

    protected processTipoviNadogradnjePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    tipoviNadogradnjeDELETE(id: number): Promise<Tip_nadogradnje> {
        let url_ = this.baseUrl + "/api/TipoviNadogradnje/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviNadogradnjeDELETE(_response);
        });
    }

    protected processTipoviNadogradnjeDELETE(response: Response): Promise<Tip_nadogradnje> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Tip_nadogradnje.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_nadogradnje>(null as any);
    }

    /**
     * @return OK
     */
    tipoviVozilaAll(): Promise<Tip_vozila[]> {
        let url_ = this.baseUrl + "/api/TipoviVozila";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviVozilaAll(_response);
        });
    }

    protected processTipoviVozilaAll(response: Response): Promise<Tip_vozila[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Tip_vozila.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_vozila[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    tipoviVozilaPOST(body: Tip_vozila | undefined): Promise<Tip_vozila> {
        let url_ = this.baseUrl + "/api/TipoviVozila";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviVozilaPOST(_response);
        });
    }

    protected processTipoviVozilaPOST(response: Response): Promise<Tip_vozila> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Tip_vozila.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_vozila>(null as any);
    }

    /**
     * @return OK
     */
    tipoviVozilaGET(id: number): Promise<Tip_vozila> {
        let url_ = this.baseUrl + "/api/TipoviVozila/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviVozilaGET(_response);
        });
    }

    protected processTipoviVozilaGET(response: Response): Promise<Tip_vozila> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Tip_vozila.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_vozila>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    tipoviVozilaPUT(id: number, body: Tip_vozila | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TipoviVozila/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviVozilaPUT(_response);
        });
    }

    protected processTipoviVozilaPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    tipoviVozilaDELETE(id: number): Promise<Tip_vozila> {
        let url_ = this.baseUrl + "/api/TipoviVozila/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTipoviVozilaDELETE(_response);
        });
    }

    protected processTipoviVozilaDELETE(response: Response): Promise<Tip_vozila> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Tip_vozila.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tip_vozila>(null as any);
    }

    /**
     * @return OK
     */
    transportPonudeAll(dateFrom: Date, dateTo: Date, drzavaIz: number, drzavaZa: number, tipNadogradnje: number, utovar: number): Promise<Transport_ponudum[]> {
        let url_ = this.baseUrl + "/api/TransportPonude/{dateFrom}/{dateTo}/{drzavaIz}/{drzavaZa}/{tipNadogradnje}/{utovar}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        if (drzavaIz === undefined || drzavaIz === null)
            throw new globalThis.Error("The parameter 'drzavaIz' must be defined.");
        url_ = url_.replace("{drzavaIz}", encodeURIComponent("" + drzavaIz));
        if (drzavaZa === undefined || drzavaZa === null)
            throw new globalThis.Error("The parameter 'drzavaZa' must be defined.");
        url_ = url_.replace("{drzavaZa}", encodeURIComponent("" + drzavaZa));
        if (tipNadogradnje === undefined || tipNadogradnje === null)
            throw new globalThis.Error("The parameter 'tipNadogradnje' must be defined.");
        url_ = url_.replace("{tipNadogradnje}", encodeURIComponent("" + tipNadogradnje));
        if (utovar === undefined || utovar === null)
            throw new globalThis.Error("The parameter 'utovar' must be defined.");
        url_ = url_.replace("{utovar}", encodeURIComponent("" + utovar));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTransportPonudeAll(_response);
        });
    }

    protected processTransportPonudeAll(response: Response): Promise<Transport_ponudum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Transport_ponudum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transport_ponudum[]>(null as any);
    }

    /**
     * @return OK
     */
    transportPonudeGET(id: number): Promise<Transport_ponudum> {
        let url_ = this.baseUrl + "/api/TransportPonude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTransportPonudeGET(_response);
        });
    }

    protected processTransportPonudeGET(response: Response): Promise<Transport_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Transport_ponudum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transport_ponudum>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    transportPonudePUT(id: number, body: Transport_ponudum | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TransportPonude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTransportPonudePUT(_response);
        });
    }

    protected processTransportPonudePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    transportPonudeDELETE(id: number): Promise<Transport_ponudum> {
        let url_ = this.baseUrl + "/api/TransportPonude/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTransportPonudeDELETE(_response);
        });
    }

    protected processTransportPonudeDELETE(response: Response): Promise<Transport_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Transport_ponudum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transport_ponudum>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    transportPonudePOST(body: Transport_ponudum | undefined): Promise<Transport_ponudum> {
        let url_ = this.baseUrl + "/api/TransportPonude";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processTransportPonudePOST(_response);
        });
    }

    protected processTransportPonudePOST(response: Response): Promise<Transport_ponudum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Transport_ponudum.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transport_ponudum>(null as any);
    }

    /**
     * @return OK
     */
    valuteAll(): Promise<Valutum[]> {
        let url_ = this.baseUrl + "/api/Valute";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processValuteAll(_response);
        });
    }

    protected processValuteAll(response: Response): Promise<Valutum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Valutum.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Valutum[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    valutePOST(body: Valutum | undefined): Promise<Valutum> {
        let url_ = this.baseUrl + "/api/Valute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processValutePOST(_response);
        });
    }

    protected processValutePOST(response: Response): Promise<Valutum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Valutum.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Valutum>(null as any);
    }

    /**
     * @return OK
     */
    valuteGET(id: number): Promise<Valutum> {
        let url_ = this.baseUrl + "/api/Valute/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processValuteGET(_response);
        });
    }

    protected processValuteGET(response: Response): Promise<Valutum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Valutum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Valutum>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    valutePUT(id: number, body: Valutum | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Valute/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processValutePUT(_response);
        });
    }

    protected processValutePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    valuteDELETE(id: number): Promise<Valutum> {
        let url_ = this.baseUrl + "/api/Valute/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processValuteDELETE(_response);
        });
    }

    protected processValuteDELETE(response: Response): Promise<Valutum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Valutum.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Valutum>(null as any);
    }

    /**
     * @return OK
     */
    vaznaObavjestenjaAll(dateFrom: Date, dateTo: Date): Promise<Vazna_obavjestenja[]> {
        let url_ = this.baseUrl + "/api/VaznaObavjestenja/{dateFrom}/{dateTo}";
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateTo === undefined || dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' must be defined.");
        url_ = url_.replace("{dateTo}", encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processVaznaObavjestenjaAll(_response);
        });
    }

    protected processVaznaObavjestenjaAll(response: Response): Promise<Vazna_obavjestenja[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Vazna_obavjestenja.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vazna_obavjestenja[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    vaznaObavjestenjaPOST(body: Vazna_obavjestenja | undefined): Promise<Vazna_obavjestenja> {
        let url_ = this.baseUrl + "/api/VaznaObavjestenja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processVaznaObavjestenjaPOST(_response);
        });
    }

    protected processVaznaObavjestenjaPOST(response: Response): Promise<Vazna_obavjestenja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Vazna_obavjestenja.fromJS(resultData201);
                return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vazna_obavjestenja>(null as any);
    }

    /**
     * @return OK
     */
    vaznaObavjestenjaDELETE(id: number): Promise<Vazna_obavjestenja> {
        let url_ = this.baseUrl + "/api/VaznaObavjestenja/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.httpFetch(url_, options_).then((_response: Response) => {
            return this.processVaznaObavjestenjaDELETE(_response);
        });
    }

    protected processVaznaObavjestenjaDELETE(response: Response): Promise<Vazna_obavjestenja> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Vazna_obavjestenja.fromJS(resultData200);
                return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Vazna_obavjestenja>(null as any);
    }
}

export class Cijene implements ICijene {
    artikl?: string | undefined;
    opis?: string | undefined;
    min?: number;
    max?: number;
    avg?: number;
    valutaThing?: string | undefined;

    constructor(data?: ICijene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artikl = _data["artikl"];
            this.opis = _data["opis"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.avg = _data["avg"];
            this.valutaThing = _data["valutaThing"];
        }
    }

    static fromJS(data: any): Cijene {
        data = typeof data === 'object' ? data : {};
        let result = new Cijene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artikl"] = this.artikl;
        data["opis"] = this.opis;
        data["min"] = this.min;
        data["max"] = this.max;
        data["avg"] = this.avg;
        data["valutaThing"] = this.valutaThing;
        return data;
    }
}

export interface ICijene {
    artikl?: string | undefined;
    opis?: string | undefined;
    min?: number;
    max?: number;
    avg?: number;
    valutaThing?: string | undefined;
}

export class KretanjeCijena implements IKretanjeCijena {
    cijene?: { [key: string]: Cijene; } | undefined;
    yAxis?: string | undefined;

    constructor(data?: IKretanjeCijena) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["cijene"]) {
                this.cijene = {} as any;
                for (let key in _data["cijene"]) {
                    if (_data["cijene"].hasOwnProperty(key))
                        (this.cijene as any)![key] = _data["cijene"][key] ? Cijene.fromJS(_data["cijene"][key]) : new Cijene();
                }
            }
            this.yAxis = _data["yAxis"];
        }
    }

    static fromJS(data: any): KretanjeCijena {
        data = typeof data === 'object' ? data : {};
        let result = new KretanjeCijena();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.cijene) {
            data["cijene"] = {};
            for (let key in this.cijene) {
                if (this.cijene.hasOwnProperty(key))
                    (data["cijene"] as any)[key] = this.cijene[key] ? this.cijene[key].toJSON() : undefined as any;
            }
        }
        data["yAxis"] = this.yAxis;
        return data;
    }
}

export interface IKretanjeCijena {
    cijene?: { [key: string]: Cijene; } | undefined;
    yAxis?: string | undefined;
}

export class Login implements ILogin {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    firma?: number | undefined;
    aktivan?: number | undefined;
    token?: string | undefined;
    user_agro?: boolean | undefined;
    user_transport?: boolean | undefined;
    mod_agro?: boolean | undefined;
    mod_transport?: boolean | undefined;
    owner_agro?: boolean | undefined;
    owner_transport?: boolean | undefined;
    firmaObject?: Firma;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.firma = _data["firma"];
            this.aktivan = _data["aktivan"];
            this.token = _data["token"];
            this.user_agro = _data["user_agro"];
            this.user_transport = _data["user_transport"];
            this.mod_agro = _data["mod_agro"];
            this.mod_transport = _data["mod_transport"];
            this.owner_agro = _data["owner_agro"];
            this.owner_transport = _data["owner_transport"];
            this.firmaObject = _data["firmaObject"] ? Firma.fromJS(_data["firmaObject"]) : undefined as any;
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["password"] = this.password;
        data["firma"] = this.firma;
        data["aktivan"] = this.aktivan;
        data["token"] = this.token;
        data["user_agro"] = this.user_agro;
        data["user_transport"] = this.user_transport;
        data["mod_agro"] = this.mod_agro;
        data["mod_transport"] = this.mod_transport;
        data["owner_agro"] = this.owner_agro;
        data["owner_transport"] = this.owner_transport;
        data["firmaObject"] = this.firmaObject ? this.firmaObject.toJSON() : undefined as any;
        return data;
    }
}

export interface ILogin {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    firma?: number | undefined;
    aktivan?: number | undefined;
    token?: string | undefined;
    user_agro?: boolean | undefined;
    user_transport?: boolean | undefined;
    mod_agro?: boolean | undefined;
    mod_transport?: boolean | undefined;
    owner_agro?: boolean | undefined;
    owner_transport?: boolean | undefined;
    firmaObject?: Firma;
}

export class LoginExtendedModel implements ILoginExtendedModel {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    firma?: number | undefined;
    aktivan?: number | undefined;
    token?: string | undefined;
    user_agro?: boolean | undefined;
    user_transport?: boolean | undefined;
    mod_agro?: boolean | undefined;
    mod_transport?: boolean | undefined;
    owner_agro?: boolean | undefined;
    owner_transport?: boolean | undefined;
    firmaObject?: Firma;
    roles?: string[] | undefined;

    constructor(data?: ILoginExtendedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.firma = _data["firma"];
            this.aktivan = _data["aktivan"];
            this.token = _data["token"];
            this.user_agro = _data["user_agro"];
            this.user_transport = _data["user_transport"];
            this.mod_agro = _data["mod_agro"];
            this.mod_transport = _data["mod_transport"];
            this.owner_agro = _data["owner_agro"];
            this.owner_transport = _data["owner_transport"];
            this.firmaObject = _data["firmaObject"] ? Firma.fromJS(_data["firmaObject"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): LoginExtendedModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginExtendedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["password"] = this.password;
        data["firma"] = this.firma;
        data["aktivan"] = this.aktivan;
        data["token"] = this.token;
        data["user_agro"] = this.user_agro;
        data["user_transport"] = this.user_transport;
        data["mod_agro"] = this.mod_agro;
        data["mod_transport"] = this.mod_transport;
        data["owner_agro"] = this.owner_agro;
        data["owner_transport"] = this.owner_transport;
        data["firmaObject"] = this.firmaObject ? this.firmaObject.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ILoginExtendedModel {
    id?: number;
    username?: string | undefined;
    password?: string | undefined;
    firma?: number | undefined;
    aktivan?: number | undefined;
    token?: string | undefined;
    user_agro?: boolean | undefined;
    user_transport?: boolean | undefined;
    mod_agro?: boolean | undefined;
    mod_transport?: boolean | undefined;
    owner_agro?: boolean | undefined;
    owner_transport?: boolean | undefined;
    firmaObject?: Firma;
    roles?: string[] | undefined;
}

export class MenuCountResult implements IMenuCountResult {
    d?: Date;
    bihPonude?: number;
    srbPonude?: number;
    hrvPonude?: number;
    inoPonude?: number;
    bihPotraznje?: number;
    hrvPotraznje?: number;
    srbPotraznje?: number;
    inoPotraznje?: number;

    constructor(data?: IMenuCountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.d = _data["d"] ? new Date(_data["d"].toString()) : undefined as any;
            this.bihPonude = _data["bihPonude"];
            this.srbPonude = _data["srbPonude"];
            this.hrvPonude = _data["hrvPonude"];
            this.inoPonude = _data["inoPonude"];
            this.bihPotraznje = _data["bihPotraznje"];
            this.hrvPotraznje = _data["hrvPotraznje"];
            this.srbPotraznje = _data["srbPotraznje"];
            this.inoPotraznje = _data["inoPotraznje"];
        }
    }

    static fromJS(data: any): MenuCountResult {
        data = typeof data === 'object' ? data : {};
        let result = new MenuCountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["d"] = this.d ? this.d.toISOString() : undefined as any;
        data["bihPonude"] = this.bihPonude;
        data["srbPonude"] = this.srbPonude;
        data["hrvPonude"] = this.hrvPonude;
        data["inoPonude"] = this.inoPonude;
        data["bihPotraznje"] = this.bihPotraznje;
        data["hrvPotraznje"] = this.hrvPotraznje;
        data["srbPotraznje"] = this.srbPotraznje;
        data["inoPotraznje"] = this.inoPotraznje;
        return data;
    }
}

export interface IMenuCountResult {
    d?: Date;
    bihPonude?: number;
    srbPonude?: number;
    hrvPonude?: number;
    inoPonude?: number;
    bihPotraznje?: number;
    hrvPotraznje?: number;
    srbPotraznje?: number;
    inoPotraznje?: number;
}

export class MobileLogin implements IMobileLogin {
    username?: string | undefined;
    password?: string | undefined;
    mobileToken?: string | undefined;
    notifications?: string | undefined;

    constructor(data?: IMobileLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.mobileToken = _data["mobileToken"];
            this.notifications = _data["notifications"];
        }
    }

    static fromJS(data: any): MobileLogin {
        data = typeof data === 'object' ? data : {};
        let result = new MobileLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["mobileToken"] = this.mobileToken;
        data["notifications"] = this.notifications;
        return data;
    }
}

export interface IMobileLogin {
    username?: string | undefined;
    password?: string | undefined;
    mobileToken?: string | undefined;
    notifications?: string | undefined;
}

export class PdfInput implements IPdfInput {
    artikl?: number;
    opisi?: number[] | undefined;

    constructor(data?: IPdfInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artikl = _data["artikl"];
            if (Array.isArray(_data["opisi"])) {
                this.opisi = [] as any;
                for (let item of _data["opisi"])
                    this.opisi!.push(item);
            }
        }
    }

    static fromJS(data: any): PdfInput {
        data = typeof data === 'object' ? data : {};
        let result = new PdfInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artikl"] = this.artikl;
        if (Array.isArray(this.opisi)) {
            data["opisi"] = [];
            for (let item of this.opisi)
                data["opisi"].push(item);
        }
        return data;
    }
}

export interface IPdfInput {
    artikl?: number;
    opisi?: number[] | undefined;
}

export class Permission implements IPermission {
    permissionName?: string | undefined;
    guest?: boolean;
    agroUser?: boolean;
    agroMod?: boolean;
    agroOwner?: boolean;
    transportUser?: boolean;
    transportMod?: boolean;
    transportOwner?: boolean;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionName = _data["permissionName"];
            this.guest = _data["guest"];
            this.agroUser = _data["agroUser"];
            this.agroMod = _data["agroMod"];
            this.agroOwner = _data["agroOwner"];
            this.transportUser = _data["transportUser"];
            this.transportMod = _data["transportMod"];
            this.transportOwner = _data["transportOwner"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionName"] = this.permissionName;
        data["guest"] = this.guest;
        data["agroUser"] = this.agroUser;
        data["agroMod"] = this.agroMod;
        data["agroOwner"] = this.agroOwner;
        data["transportUser"] = this.transportUser;
        data["transportMod"] = this.transportMod;
        data["transportOwner"] = this.transportOwner;
        return data;
    }
}

export interface IPermission {
    permissionName?: string | undefined;
    guest?: boolean;
    agroUser?: boolean;
    agroMod?: boolean;
    agroOwner?: boolean;
    transportUser?: boolean;
    transportMod?: boolean;
    transportOwner?: boolean;
}

export class PoslovniImenik implements IPoslovniImenik {
    nazivFirme?: string | undefined;
    djelatnost?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    kontaktOsoba?: string | undefined;
    telefon?: string | undefined;
    artikli?: string | undefined;
    direktor?: string | undefined;
    oblast?: string | undefined;

    constructor(data?: IPoslovniImenik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivFirme = _data["nazivFirme"];
            this.djelatnost = _data["djelatnost"];
            this.grad = _data["grad"];
            this.drzava = _data["drzava"];
            this.kontaktOsoba = _data["kontaktOsoba"];
            this.telefon = _data["telefon"];
            this.artikli = _data["artikli"];
            this.direktor = _data["direktor"];
            this.oblast = _data["oblast"];
        }
    }

    static fromJS(data: any): PoslovniImenik {
        data = typeof data === 'object' ? data : {};
        let result = new PoslovniImenik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivFirme"] = this.nazivFirme;
        data["djelatnost"] = this.djelatnost;
        data["grad"] = this.grad;
        data["drzava"] = this.drzava;
        data["kontaktOsoba"] = this.kontaktOsoba;
        data["telefon"] = this.telefon;
        data["artikli"] = this.artikli;
        data["direktor"] = this.direktor;
        data["oblast"] = this.oblast;
        return data;
    }
}

export interface IPoslovniImenik {
    nazivFirme?: string | undefined;
    djelatnost?: string | undefined;
    grad?: string | undefined;
    drzava?: string | undefined;
    kontaktOsoba?: string | undefined;
    telefon?: string | undefined;
    artikli?: string | undefined;
    direktor?: string | undefined;
    oblast?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Anonimni_kontakt implements IAnonimni_kontakt {
    id?: number;
    datum?: Date | undefined;
    naziv?: string | undefined;
    kontakt?: string | undefined;
    tekst?: string | undefined;

    constructor(data?: IAnonimni_kontakt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.naziv = _data["naziv"];
            this.kontakt = _data["kontakt"];
            this.tekst = _data["tekst"];
        }
    }

    static fromJS(data: any): Anonimni_kontakt {
        data = typeof data === 'object' ? data : {};
        let result = new Anonimni_kontakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datum"] = this.datum ? formatDate(this.datum) : undefined as any;
        data["naziv"] = this.naziv;
        data["kontakt"] = this.kontakt;
        data["tekst"] = this.tekst;
        return data;
    }
}

export interface IAnonimni_kontakt {
    id?: number;
    datum?: Date | undefined;
    naziv?: string | undefined;
    kontakt?: string | undefined;
    tekst?: string | undefined;
}

export class Artikl implements IArtikl {
    id?: number;
    artikl1?: string | undefined;
    opis?: string | undefined;
    javna_ponuda?: Javna_ponudum[] | undefined;
    javna_potraznja?: Javna_potraznja[] | undefined;
    sms_sort?: Sms_sort[] | undefined;

    constructor(data?: IArtikl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.artikl1 = _data["artikl1"];
            this.opis = _data["opis"];
            if (Array.isArray(_data["javna_ponuda"])) {
                this.javna_ponuda = [] as any;
                for (let item of _data["javna_ponuda"])
                    this.javna_ponuda!.push(Javna_ponudum.fromJS(item));
            }
            if (Array.isArray(_data["javna_potraznja"])) {
                this.javna_potraznja = [] as any;
                for (let item of _data["javna_potraznja"])
                    this.javna_potraznja!.push(Javna_potraznja.fromJS(item));
            }
            if (Array.isArray(_data["sms_sort"])) {
                this.sms_sort = [] as any;
                for (let item of _data["sms_sort"])
                    this.sms_sort!.push(Sms_sort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Artikl {
        data = typeof data === 'object' ? data : {};
        let result = new Artikl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artikl1"] = this.artikl1;
        data["opis"] = this.opis;
        if (Array.isArray(this.javna_ponuda)) {
            data["javna_ponuda"] = [];
            for (let item of this.javna_ponuda)
                data["javna_ponuda"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.javna_potraznja)) {
            data["javna_potraznja"] = [];
            for (let item of this.javna_potraznja)
                data["javna_potraznja"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sms_sort)) {
            data["sms_sort"] = [];
            for (let item of this.sms_sort)
                data["sms_sort"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IArtikl {
    id?: number;
    artikl1?: string | undefined;
    opis?: string | undefined;
    javna_ponuda?: Javna_ponudum[] | undefined;
    javna_potraznja?: Javna_potraznja[] | undefined;
    sms_sort?: Sms_sort[] | undefined;
}

export class Djelatnost_firme implements IDjelatnost_firme {
    id?: number;
    djelatnost?: string | undefined;
    firmas?: Firma[] | undefined;

    constructor(data?: IDjelatnost_firme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.djelatnost = _data["djelatnost"];
            if (Array.isArray(_data["firmas"])) {
                this.firmas = [] as any;
                for (let item of _data["firmas"])
                    this.firmas!.push(Firma.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Djelatnost_firme {
        data = typeof data === 'object' ? data : {};
        let result = new Djelatnost_firme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["djelatnost"] = this.djelatnost;
        if (Array.isArray(this.firmas)) {
            data["firmas"] = [];
            for (let item of this.firmas)
                data["firmas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDjelatnost_firme {
    id?: number;
    djelatnost?: string | undefined;
    firmas?: Firma[] | undefined;
}

export class Drzava implements IDrzava {
    id?: number;
    naziv?: string | undefined;

    constructor(data?: IDrzava) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): Drzava {
        data = typeof data === 'object' ? data : {};
        let result = new Drzava();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IDrzava {
    id?: number;
    naziv?: string | undefined;
}

export class Firma implements IFirma {
    id?: number;
    naziv?: string | undefined;
    status?: number | undefined;
    oblast?: number | undefined;
    djelatnost?: number | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    fax?: string | undefined;
    mobilni?: string | undefined;
    mobilni_sms?: string | undefined;
    direktor?: string | undefined;
    kontakt1?: string | undefined;
    kontakt2?: string | undefined;
    adresa?: string | undefined;
    grad?: number | undefined;
    drzava?: number | undefined;
    racun?: string | undefined;
    pdv_br?: string | undefined;
    oib_br?: string | undefined;
    email?: string | undefined;
    web?: string | undefined;
    datum_kontakta?: Date | undefined;
    logo?: string | undefined;
    sifra?: string | undefined;
    period_od?: Date | undefined;
    period_do?: Date | undefined;
    domaca?: number | undefined;
    djelatnost_firme?: Djelatnost_firme;
    drzava1?: Drzava;
    grad1?: Grad;
    oblast_firme?: Oblast_firme;
    status_firme?: Status_firme;

    constructor(data?: IFirma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.status = _data["status"];
            this.oblast = _data["oblast"];
            this.djelatnost = _data["djelatnost"];
            this.telefon1 = _data["telefon1"];
            this.telefon2 = _data["telefon2"];
            this.fax = _data["fax"];
            this.mobilni = _data["mobilni"];
            this.mobilni_sms = _data["mobilni_sms"];
            this.direktor = _data["direktor"];
            this.kontakt1 = _data["kontakt1"];
            this.kontakt2 = _data["kontakt2"];
            this.adresa = _data["adresa"];
            this.grad = _data["grad"];
            this.drzava = _data["drzava"];
            this.racun = _data["racun"];
            this.pdv_br = _data["pdv_br"];
            this.oib_br = _data["oib_br"];
            this.email = _data["email"];
            this.web = _data["web"];
            this.datum_kontakta = _data["datum_kontakta"] ? new Date(_data["datum_kontakta"].toString()) : undefined as any;
            this.logo = _data["logo"];
            this.sifra = _data["sifra"];
            this.period_od = _data["period_od"] ? new Date(_data["period_od"].toString()) : undefined as any;
            this.period_do = _data["period_do"] ? new Date(_data["period_do"].toString()) : undefined as any;
            this.domaca = _data["domaca"];
            this.djelatnost_firme = _data["djelatnost_firme"] ? Djelatnost_firme.fromJS(_data["djelatnost_firme"]) : undefined as any;
            this.drzava1 = _data["drzava1"] ? Drzava.fromJS(_data["drzava1"]) : undefined as any;
            this.grad1 = _data["grad1"] ? Grad.fromJS(_data["grad1"]) : undefined as any;
            this.oblast_firme = _data["oblast_firme"] ? Oblast_firme.fromJS(_data["oblast_firme"]) : undefined as any;
            this.status_firme = _data["status_firme"] ? Status_firme.fromJS(_data["status_firme"]) : undefined as any;
        }
    }

    static fromJS(data: any): Firma {
        data = typeof data === 'object' ? data : {};
        let result = new Firma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["status"] = this.status;
        data["oblast"] = this.oblast;
        data["djelatnost"] = this.djelatnost;
        data["telefon1"] = this.telefon1;
        data["telefon2"] = this.telefon2;
        data["fax"] = this.fax;
        data["mobilni"] = this.mobilni;
        data["mobilni_sms"] = this.mobilni_sms;
        data["direktor"] = this.direktor;
        data["kontakt1"] = this.kontakt1;
        data["kontakt2"] = this.kontakt2;
        data["adresa"] = this.adresa;
        data["grad"] = this.grad;
        data["drzava"] = this.drzava;
        data["racun"] = this.racun;
        data["pdv_br"] = this.pdv_br;
        data["oib_br"] = this.oib_br;
        data["email"] = this.email;
        data["web"] = this.web;
        data["datum_kontakta"] = this.datum_kontakta ? formatDate(this.datum_kontakta) : undefined as any;
        data["logo"] = this.logo;
        data["sifra"] = this.sifra;
        data["period_od"] = this.period_od ? formatDate(this.period_od) : undefined as any;
        data["period_do"] = this.period_do ? formatDate(this.period_do) : undefined as any;
        data["domaca"] = this.domaca;
        data["djelatnost_firme"] = this.djelatnost_firme ? this.djelatnost_firme.toJSON() : undefined as any;
        data["drzava1"] = this.drzava1 ? this.drzava1.toJSON() : undefined as any;
        data["grad1"] = this.grad1 ? this.grad1.toJSON() : undefined as any;
        data["oblast_firme"] = this.oblast_firme ? this.oblast_firme.toJSON() : undefined as any;
        data["status_firme"] = this.status_firme ? this.status_firme.toJSON() : undefined as any;
        return data;
    }
}

export interface IFirma {
    id?: number;
    naziv?: string | undefined;
    status?: number | undefined;
    oblast?: number | undefined;
    djelatnost?: number | undefined;
    telefon1?: string | undefined;
    telefon2?: string | undefined;
    fax?: string | undefined;
    mobilni?: string | undefined;
    mobilni_sms?: string | undefined;
    direktor?: string | undefined;
    kontakt1?: string | undefined;
    kontakt2?: string | undefined;
    adresa?: string | undefined;
    grad?: number | undefined;
    drzava?: number | undefined;
    racun?: string | undefined;
    pdv_br?: string | undefined;
    oib_br?: string | undefined;
    email?: string | undefined;
    web?: string | undefined;
    datum_kontakta?: Date | undefined;
    logo?: string | undefined;
    sifra?: string | undefined;
    period_od?: Date | undefined;
    period_do?: Date | undefined;
    domaca?: number | undefined;
    djelatnost_firme?: Djelatnost_firme;
    drzava1?: Drzava;
    grad1?: Grad;
    oblast_firme?: Oblast_firme;
    status_firme?: Status_firme;
}

export class Grad implements IGrad {
    id?: number;
    grad1?: string | undefined;
    broj_poste?: number | undefined;

    constructor(data?: IGrad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grad1 = _data["grad1"];
            this.broj_poste = _data["broj_poste"];
        }
    }

    static fromJS(data: any): Grad {
        data = typeof data === 'object' ? data : {};
        let result = new Grad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grad1"] = this.grad1;
        data["broj_poste"] = this.broj_poste;
        return data;
    }
}

export interface IGrad {
    id?: number;
    grad1?: string | undefined;
    broj_poste?: number | undefined;
}

export class Iplog implements IIplog {
    id?: number;
    username?: string | undefined;
    ip?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IIplog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.ip = _data["ip"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Iplog {
        data = typeof data === 'object' ? data : {};
        let result = new Iplog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["ip"] = this.ip;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IIplog {
    id?: number;
    username?: string | undefined;
    ip?: string | undefined;
    date?: Date | undefined;
}

export class Javna_ponudum implements IJavna_ponudum {
    id?: number;
    artikl?: number | undefined;
    opis?: string | undefined;
    kolicina?: number | undefined;
    jedinica_mjere?: number | undefined;
    fco?: number | undefined;
    mjesto_utovara?: string | undefined;
    cijena?: number | undefined;
    valuta?: number | undefined;
    pdv?: string | undefined;
    nacin_placanja?: string | undefined;
    za_drzavu?: number | undefined;
    za_domace?: number | undefined;
    za_izvoz?: number | undefined;
    dodatni_opis?: string | undefined;
    firma?: number | undefined;
    datum?: Date | undefined;
    po_jedinica_mjere?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;
    jedinica_mjere1?: Jedinica_mjere;
    jedinica_mjere2?: Jedinica_mjere;
    valuta1?: Valutum;
    drzava?: Drzava;

    constructor(data?: IJavna_ponudum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.artikl = _data["artikl"];
            this.opis = _data["opis"];
            this.kolicina = _data["kolicina"];
            this.jedinica_mjere = _data["jedinica_mjere"];
            this.fco = _data["fco"];
            this.mjesto_utovara = _data["mjesto_utovara"];
            this.cijena = _data["cijena"];
            this.valuta = _data["valuta"];
            this.pdv = _data["pdv"];
            this.nacin_placanja = _data["nacin_placanja"];
            this.za_drzavu = _data["za_drzavu"];
            this.za_domace = _data["za_domace"];
            this.za_izvoz = _data["za_izvoz"];
            this.dodatni_opis = _data["dodatni_opis"];
            this.firma = _data["firma"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.po_jedinica_mjere = _data["po_jedinica_mjere"];
            this.artikl1 = _data["artikl1"] ? Artikl.fromJS(_data["artikl1"]) : undefined as any;
            this.firma1 = _data["firma1"] ? Firma.fromJS(_data["firma1"]) : undefined as any;
            this.jedinica_mjere1 = _data["jedinica_mjere1"] ? Jedinica_mjere.fromJS(_data["jedinica_mjere1"]) : undefined as any;
            this.jedinica_mjere2 = _data["jedinica_mjere2"] ? Jedinica_mjere.fromJS(_data["jedinica_mjere2"]) : undefined as any;
            this.valuta1 = _data["valuta1"] ? Valutum.fromJS(_data["valuta1"]) : undefined as any;
            this.drzava = _data["drzava"] ? Drzava.fromJS(_data["drzava"]) : undefined as any;
        }
    }

    static fromJS(data: any): Javna_ponudum {
        data = typeof data === 'object' ? data : {};
        let result = new Javna_ponudum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artikl"] = this.artikl;
        data["opis"] = this.opis;
        data["kolicina"] = this.kolicina;
        data["jedinica_mjere"] = this.jedinica_mjere;
        data["fco"] = this.fco;
        data["mjesto_utovara"] = this.mjesto_utovara;
        data["cijena"] = this.cijena;
        data["valuta"] = this.valuta;
        data["pdv"] = this.pdv;
        data["nacin_placanja"] = this.nacin_placanja;
        data["za_drzavu"] = this.za_drzavu;
        data["za_domace"] = this.za_domace;
        data["za_izvoz"] = this.za_izvoz;
        data["dodatni_opis"] = this.dodatni_opis;
        data["firma"] = this.firma;
        data["datum"] = this.datum ? formatDate(this.datum) : undefined as any;
        data["po_jedinica_mjere"] = this.po_jedinica_mjere;
        data["artikl1"] = this.artikl1 ? this.artikl1.toJSON() : undefined as any;
        data["firma1"] = this.firma1 ? this.firma1.toJSON() : undefined as any;
        data["jedinica_mjere1"] = this.jedinica_mjere1 ? this.jedinica_mjere1.toJSON() : undefined as any;
        data["jedinica_mjere2"] = this.jedinica_mjere2 ? this.jedinica_mjere2.toJSON() : undefined as any;
        data["valuta1"] = this.valuta1 ? this.valuta1.toJSON() : undefined as any;
        data["drzava"] = this.drzava ? this.drzava.toJSON() : undefined as any;
        return data;
    }
}

export interface IJavna_ponudum {
    id?: number;
    artikl?: number | undefined;
    opis?: string | undefined;
    kolicina?: number | undefined;
    jedinica_mjere?: number | undefined;
    fco?: number | undefined;
    mjesto_utovara?: string | undefined;
    cijena?: number | undefined;
    valuta?: number | undefined;
    pdv?: string | undefined;
    nacin_placanja?: string | undefined;
    za_drzavu?: number | undefined;
    za_domace?: number | undefined;
    za_izvoz?: number | undefined;
    dodatni_opis?: string | undefined;
    firma?: number | undefined;
    datum?: Date | undefined;
    po_jedinica_mjere?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;
    jedinica_mjere1?: Jedinica_mjere;
    jedinica_mjere2?: Jedinica_mjere;
    valuta1?: Valutum;
    drzava?: Drzava;
}

export class Javna_potraznja implements IJavna_potraznja {
    id?: number;
    artikl?: number | undefined;
    opis?: string | undefined;
    kolicina?: number | undefined;
    jedinica_mjere?: number | undefined;
    fco?: number | undefined;
    mjesto_utovara?: string | undefined;
    cijena?: number | undefined;
    valuta?: number | undefined;
    pdv?: string | undefined;
    nacin_placanja?: string | undefined;
    za_drzavu?: number | undefined;
    za_domace?: number | undefined;
    za_izvoz?: number | undefined;
    dodatni_opis?: string | undefined;
    firma?: number | undefined;
    datum?: Date | undefined;
    po_jedinica_mjere?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;
    jedinica_mjere1?: Jedinica_mjere;
    jedinica_mjere2?: Jedinica_mjere;
    valuta1?: Valutum;
    drzava?: Drzava;

    constructor(data?: IJavna_potraznja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.artikl = _data["artikl"];
            this.opis = _data["opis"];
            this.kolicina = _data["kolicina"];
            this.jedinica_mjere = _data["jedinica_mjere"];
            this.fco = _data["fco"];
            this.mjesto_utovara = _data["mjesto_utovara"];
            this.cijena = _data["cijena"];
            this.valuta = _data["valuta"];
            this.pdv = _data["pdv"];
            this.nacin_placanja = _data["nacin_placanja"];
            this.za_drzavu = _data["za_drzavu"];
            this.za_domace = _data["za_domace"];
            this.za_izvoz = _data["za_izvoz"];
            this.dodatni_opis = _data["dodatni_opis"];
            this.firma = _data["firma"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.po_jedinica_mjere = _data["po_jedinica_mjere"];
            this.artikl1 = _data["artikl1"] ? Artikl.fromJS(_data["artikl1"]) : undefined as any;
            this.firma1 = _data["firma1"] ? Firma.fromJS(_data["firma1"]) : undefined as any;
            this.jedinica_mjere1 = _data["jedinica_mjere1"] ? Jedinica_mjere.fromJS(_data["jedinica_mjere1"]) : undefined as any;
            this.jedinica_mjere2 = _data["jedinica_mjere2"] ? Jedinica_mjere.fromJS(_data["jedinica_mjere2"]) : undefined as any;
            this.valuta1 = _data["valuta1"] ? Valutum.fromJS(_data["valuta1"]) : undefined as any;
            this.drzava = _data["drzava"] ? Drzava.fromJS(_data["drzava"]) : undefined as any;
        }
    }

    static fromJS(data: any): Javna_potraznja {
        data = typeof data === 'object' ? data : {};
        let result = new Javna_potraznja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artikl"] = this.artikl;
        data["opis"] = this.opis;
        data["kolicina"] = this.kolicina;
        data["jedinica_mjere"] = this.jedinica_mjere;
        data["fco"] = this.fco;
        data["mjesto_utovara"] = this.mjesto_utovara;
        data["cijena"] = this.cijena;
        data["valuta"] = this.valuta;
        data["pdv"] = this.pdv;
        data["nacin_placanja"] = this.nacin_placanja;
        data["za_drzavu"] = this.za_drzavu;
        data["za_domace"] = this.za_domace;
        data["za_izvoz"] = this.za_izvoz;
        data["dodatni_opis"] = this.dodatni_opis;
        data["firma"] = this.firma;
        data["datum"] = this.datum ? formatDate(this.datum) : undefined as any;
        data["po_jedinica_mjere"] = this.po_jedinica_mjere;
        data["artikl1"] = this.artikl1 ? this.artikl1.toJSON() : undefined as any;
        data["firma1"] = this.firma1 ? this.firma1.toJSON() : undefined as any;
        data["jedinica_mjere1"] = this.jedinica_mjere1 ? this.jedinica_mjere1.toJSON() : undefined as any;
        data["jedinica_mjere2"] = this.jedinica_mjere2 ? this.jedinica_mjere2.toJSON() : undefined as any;
        data["valuta1"] = this.valuta1 ? this.valuta1.toJSON() : undefined as any;
        data["drzava"] = this.drzava ? this.drzava.toJSON() : undefined as any;
        return data;
    }
}

export interface IJavna_potraznja {
    id?: number;
    artikl?: number | undefined;
    opis?: string | undefined;
    kolicina?: number | undefined;
    jedinica_mjere?: number | undefined;
    fco?: number | undefined;
    mjesto_utovara?: string | undefined;
    cijena?: number | undefined;
    valuta?: number | undefined;
    pdv?: string | undefined;
    nacin_placanja?: string | undefined;
    za_drzavu?: number | undefined;
    za_domace?: number | undefined;
    za_izvoz?: number | undefined;
    dodatni_opis?: string | undefined;
    firma?: number | undefined;
    datum?: Date | undefined;
    po_jedinica_mjere?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;
    jedinica_mjere1?: Jedinica_mjere;
    jedinica_mjere2?: Jedinica_mjere;
    valuta1?: Valutum;
    drzava?: Drzava;
}

export class Jedinica_mjere implements IJedinica_mjere {
    id?: number;
    jedinica?: string | undefined;

    constructor(data?: IJedinica_mjere) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jedinica = _data["jedinica"];
        }
    }

    static fromJS(data: any): Jedinica_mjere {
        data = typeof data === 'object' ? data : {};
        let result = new Jedinica_mjere();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jedinica"] = this.jedinica;
        return data;
    }
}

export interface IJedinica_mjere {
    id?: number;
    jedinica?: string | undefined;
}

export class Komentar implements IKomentar {
    id?: number;
    idKorisnika?: number | undefined;
    sifraFirme?: number | undefined;
    komentar1?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: IKomentar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idKorisnika = _data["idKorisnika"];
            this.sifraFirme = _data["sifraFirme"];
            this.komentar1 = _data["komentar1"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Komentar {
        data = typeof data === 'object' ? data : {};
        let result = new Komentar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idKorisnika"] = this.idKorisnika;
        data["sifraFirme"] = this.sifraFirme;
        data["komentar1"] = this.komentar1;
        data["datum"] = this.datum ? formatDate(this.datum) : undefined as any;
        return data;
    }
}

export interface IKomentar {
    id?: number;
    idKorisnika?: number | undefined;
    sifraFirme?: number | undefined;
    komentar1?: string | undefined;
    datum?: Date | undefined;
}

export class Kontakt implements IKontakt {
    id?: number;
    imeFirme?: string | undefined;
    email?: string | undefined;
    poruka?: string | undefined;

    constructor(data?: IKontakt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imeFirme = _data["imeFirme"];
            this.email = _data["email"];
            this.poruka = _data["poruka"];
        }
    }

    static fromJS(data: any): Kontakt {
        data = typeof data === 'object' ? data : {};
        let result = new Kontakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imeFirme"] = this.imeFirme;
        data["email"] = this.email;
        data["poruka"] = this.poruka;
        return data;
    }
}

export interface IKontakt {
    id?: number;
    imeFirme?: string | undefined;
    email?: string | undefined;
    poruka?: string | undefined;
}

export class Kurs_eura implements IKurs_eura {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: IKurs_eura) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Kurs_eura {
        data = typeof data === 'object' ? data : {};
        let result = new Kurs_eura();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        return data;
    }
}

export interface IKurs_eura {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;
}

export class Nudjene_cijene implements INudjene_cijene {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: INudjene_cijene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Nudjene_cijene {
        data = typeof data === 'object' ? data : {};
        let result = new Nudjene_cijene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        return data;
    }
}

export interface INudjene_cijene {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;
}

export class Obavjestenje implements IObavjestenje {
    id?: number;
    tekst?: string | undefined;

    constructor(data?: IObavjestenje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
        }
    }

    static fromJS(data: any): Obavjestenje {
        data = typeof data === 'object' ? data : {};
        let result = new Obavjestenje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        return data;
    }
}

export interface IObavjestenje {
    id?: number;
    tekst?: string | undefined;
}

export class Oblast_firme implements IOblast_firme {
    id?: number;
    oblast?: string | undefined;

    constructor(data?: IOblast_firme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oblast = _data["oblast"];
        }
    }

    static fromJS(data: any): Oblast_firme {
        data = typeof data === 'object' ? data : {};
        let result = new Oblast_firme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oblast"] = this.oblast;
        return data;
    }
}

export interface IOblast_firme {
    id?: number;
    oblast?: string | undefined;
}

export class Opi implements IOpi {
    id?: number;
    opis?: string | undefined;

    constructor(data?: IOpi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): Opi {
        data = typeof data === 'object' ? data : {};
        let result = new Opi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IOpi {
    id?: number;
    opis?: string | undefined;
}

export class Otkupne_cijene implements IOtkupne_cijene {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: IOtkupne_cijene) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Otkupne_cijene {
        data = typeof data === 'object' ? data : {};
        let result = new Otkupne_cijene();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        return data;
    }
}

export interface IOtkupne_cijene {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;
}

export class Realizacije implements IRealizacije {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: IRealizacije) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Realizacije {
        data = typeof data === 'object' ? data : {};
        let result = new Realizacije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        return data;
    }
}

export interface IRealizacije {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;
}

export class Reg_kontakt implements IReg_kontakt {
    id?: number;
    id_firme?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;

    constructor(data?: IReg_kontakt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.id_firme = _data["id_firme"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.tekst = _data["tekst"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : undefined as any;
        }
    }

    static fromJS(data: any): Reg_kontakt {
        data = typeof data === 'object' ? data : {};
        let result = new Reg_kontakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["id_firme"] = this.id_firme;
        data["datum"] = this.datum ? formatDate(this.datum) : undefined as any;
        data["tekst"] = this.tekst;
        data["firma"] = this.firma ? this.firma.toJSON() : undefined as any;
        return data;
    }
}

export interface IReg_kontakt {
    id?: number;
    id_firme?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;
}

export class Sms_ponudum implements ISms_ponudum {
    id?: number;
    id_firme?: number | undefined;
    valuta?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;
    valuta1?: Valutum;

    constructor(data?: ISms_ponudum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.id_firme = _data["id_firme"];
            this.valuta = _data["valuta"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.tekst = _data["tekst"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : undefined as any;
            this.valuta1 = _data["valuta1"] ? Valutum.fromJS(_data["valuta1"]) : undefined as any;
        }
    }

    static fromJS(data: any): Sms_ponudum {
        data = typeof data === 'object' ? data : {};
        let result = new Sms_ponudum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["id_firme"] = this.id_firme;
        data["valuta"] = this.valuta;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        data["tekst"] = this.tekst;
        data["firma"] = this.firma ? this.firma.toJSON() : undefined as any;
        data["valuta1"] = this.valuta1 ? this.valuta1.toJSON() : undefined as any;
        return data;
    }
}

export interface ISms_ponudum {
    id?: number;
    id_firme?: number | undefined;
    valuta?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;
    valuta1?: Valutum;
}

export class Sms_potraznja implements ISms_potraznja {
    id?: number;
    id_firme?: number | undefined;
    valuta?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;
    valuta1?: Valutum;

    constructor(data?: ISms_potraznja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.id_firme = _data["id_firme"];
            this.valuta = _data["valuta"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.tekst = _data["tekst"];
            this.firma = _data["firma"] ? Firma.fromJS(_data["firma"]) : undefined as any;
            this.valuta1 = _data["valuta1"] ? Valutum.fromJS(_data["valuta1"]) : undefined as any;
        }
    }

    static fromJS(data: any): Sms_potraznja {
        data = typeof data === 'object' ? data : {};
        let result = new Sms_potraznja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["id_firme"] = this.id_firme;
        data["valuta"] = this.valuta;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        data["tekst"] = this.tekst;
        data["firma"] = this.firma ? this.firma.toJSON() : undefined as any;
        data["valuta1"] = this.valuta1 ? this.valuta1.toJSON() : undefined as any;
        return data;
    }
}

export interface ISms_potraznja {
    id?: number;
    id_firme?: number | undefined;
    valuta?: number | undefined;
    datum?: Date | undefined;
    tekst?: string | undefined;
    firma?: Firma;
    valuta1?: Valutum;
}

export class Sms_sort implements ISms_sort {
    id?: number;
    firma?: number | undefined;
    artikl?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;

    constructor(data?: ISms_sort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firma = _data["firma"];
            this.artikl = _data["artikl"];
            this.artikl1 = _data["artikl1"] ? Artikl.fromJS(_data["artikl1"]) : undefined as any;
            this.firma1 = _data["firma1"] ? Firma.fromJS(_data["firma1"]) : undefined as any;
        }
    }

    static fromJS(data: any): Sms_sort {
        data = typeof data === 'object' ? data : {};
        let result = new Sms_sort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firma"] = this.firma;
        data["artikl"] = this.artikl;
        data["artikl1"] = this.artikl1 ? this.artikl1.toJSON() : undefined as any;
        data["firma1"] = this.firma1 ? this.firma1.toJSON() : undefined as any;
        return data;
    }
}

export interface ISms_sort {
    id?: number;
    firma?: number | undefined;
    artikl?: number | undefined;
    artikl1?: Artikl;
    firma1?: Firma;
}

export class Status_firme implements IStatus_firme {
    id?: number;
    status?: string | undefined;

    constructor(data?: IStatus_firme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Status_firme {
        data = typeof data === 'object' ? data : {};
        let result = new Status_firme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IStatus_firme {
    id?: number;
    status?: string | undefined;
}

export class Tip_nadogradnje implements ITip_nadogradnje {
    id?: number;
    nadogradnja?: string | undefined;

    constructor(data?: ITip_nadogradnje) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nadogradnja = _data["nadogradnja"];
        }
    }

    static fromJS(data: any): Tip_nadogradnje {
        data = typeof data === 'object' ? data : {};
        let result = new Tip_nadogradnje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nadogradnja"] = this.nadogradnja;
        return data;
    }
}

export interface ITip_nadogradnje {
    id?: number;
    nadogradnja?: string | undefined;
}

export class Tip_vozila implements ITip_vozila {
    id?: number;
    tip?: string | undefined;

    constructor(data?: ITip_vozila) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): Tip_vozila {
        data = typeof data === 'object' ? data : {};
        let result = new Tip_vozila();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tip"] = this.tip;
        return data;
    }
}

export interface ITip_vozila {
    id?: number;
    tip?: string | undefined;
}

export class Transport_ponudum implements ITransport_ponudum {
    id?: number;
    grad_iz?: number;
    drzava_iz?: number;
    grad_za?: number;
    drzava_za?: number;
    duzina?: string | undefined;
    tezina?: string | undefined;
    tip_vozila?: number;
    nadogradnja?: number;
    datum?: Date;
    id_firme?: number | undefined;
    placanje?: string | undefined;
    zbirni?: boolean | undefined;
    kompletni?: boolean | undefined;
    opis?: string | undefined;
    utovar?: boolean | undefined;
    drzavaIzObject?: Drzava;
    drzavaZaObject?: Drzava;
    gradIzObject?: Grad;
    gradZaObject?: Grad;
    firmaObject?: Firma;
    tipNadogradnjeObject?: Tip_nadogradnje;
    tipVozilaObject?: Tip_vozila;

    constructor(data?: ITransport_ponudum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grad_iz = _data["grad_iz"];
            this.drzava_iz = _data["drzava_iz"];
            this.grad_za = _data["grad_za"];
            this.drzava_za = _data["drzava_za"];
            this.duzina = _data["duzina"];
            this.tezina = _data["tezina"];
            this.tip_vozila = _data["tip_vozila"];
            this.nadogradnja = _data["nadogradnja"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.id_firme = _data["id_firme"];
            this.placanje = _data["placanje"];
            this.zbirni = _data["zbirni"];
            this.kompletni = _data["kompletni"];
            this.opis = _data["opis"];
            this.utovar = _data["utovar"];
            this.drzavaIzObject = _data["drzavaIzObject"] ? Drzava.fromJS(_data["drzavaIzObject"]) : undefined as any;
            this.drzavaZaObject = _data["drzavaZaObject"] ? Drzava.fromJS(_data["drzavaZaObject"]) : undefined as any;
            this.gradIzObject = _data["gradIzObject"] ? Grad.fromJS(_data["gradIzObject"]) : undefined as any;
            this.gradZaObject = _data["gradZaObject"] ? Grad.fromJS(_data["gradZaObject"]) : undefined as any;
            this.firmaObject = _data["firmaObject"] ? Firma.fromJS(_data["firmaObject"]) : undefined as any;
            this.tipNadogradnjeObject = _data["tipNadogradnjeObject"] ? Tip_nadogradnje.fromJS(_data["tipNadogradnjeObject"]) : undefined as any;
            this.tipVozilaObject = _data["tipVozilaObject"] ? Tip_vozila.fromJS(_data["tipVozilaObject"]) : undefined as any;
        }
    }

    static fromJS(data: any): Transport_ponudum {
        data = typeof data === 'object' ? data : {};
        let result = new Transport_ponudum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grad_iz"] = this.grad_iz;
        data["drzava_iz"] = this.drzava_iz;
        data["grad_za"] = this.grad_za;
        data["drzava_za"] = this.drzava_za;
        data["duzina"] = this.duzina;
        data["tezina"] = this.tezina;
        data["tip_vozila"] = this.tip_vozila;
        data["nadogradnja"] = this.nadogradnja;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        data["id_firme"] = this.id_firme;
        data["placanje"] = this.placanje;
        data["zbirni"] = this.zbirni;
        data["kompletni"] = this.kompletni;
        data["opis"] = this.opis;
        data["utovar"] = this.utovar;
        data["drzavaIzObject"] = this.drzavaIzObject ? this.drzavaIzObject.toJSON() : undefined as any;
        data["drzavaZaObject"] = this.drzavaZaObject ? this.drzavaZaObject.toJSON() : undefined as any;
        data["gradIzObject"] = this.gradIzObject ? this.gradIzObject.toJSON() : undefined as any;
        data["gradZaObject"] = this.gradZaObject ? this.gradZaObject.toJSON() : undefined as any;
        data["firmaObject"] = this.firmaObject ? this.firmaObject.toJSON() : undefined as any;
        data["tipNadogradnjeObject"] = this.tipNadogradnjeObject ? this.tipNadogradnjeObject.toJSON() : undefined as any;
        data["tipVozilaObject"] = this.tipVozilaObject ? this.tipVozilaObject.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransport_ponudum {
    id?: number;
    grad_iz?: number;
    drzava_iz?: number;
    grad_za?: number;
    drzava_za?: number;
    duzina?: string | undefined;
    tezina?: string | undefined;
    tip_vozila?: number;
    nadogradnja?: number;
    datum?: Date;
    id_firme?: number | undefined;
    placanje?: string | undefined;
    zbirni?: boolean | undefined;
    kompletni?: boolean | undefined;
    opis?: string | undefined;
    utovar?: boolean | undefined;
    drzavaIzObject?: Drzava;
    drzavaZaObject?: Drzava;
    gradIzObject?: Grad;
    gradZaObject?: Grad;
    firmaObject?: Firma;
    tipNadogradnjeObject?: Tip_nadogradnje;
    tipVozilaObject?: Tip_vozila;
}

export class Valutum implements IValutum {
    id?: number;
    valuta?: string | undefined;

    constructor(data?: IValutum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.valuta = _data["valuta"];
        }
    }

    static fromJS(data: any): Valutum {
        data = typeof data === 'object' ? data : {};
        let result = new Valutum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["valuta"] = this.valuta;
        return data;
    }
}

export interface IValutum {
    id?: number;
    valuta?: string | undefined;
}

export class Vazna_obavjestenja implements IVazna_obavjestenja {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;

    constructor(data?: IVazna_obavjestenja) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Vazna_obavjestenja {
        data = typeof data === 'object' ? data : {};
        let result = new Vazna_obavjestenja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        return data;
    }
}

export interface IVazna_obavjestenja {
    id?: number;
    tekst?: string | undefined;
    datum?: Date | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' +
        (d.getMonth() < 9 ? ('0' + (d.getMonth() + 1)) : (d.getMonth() + 1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}